import { buildTabsFromLabels } from 'lib/tabs';

export const ALL = 'ALL';
export const NO_CARRIER = 'NO_CARRIER';

export function isExternalType(assetUrlType) {
  if (!assetUrlType || typeof assetUrlType !== 'string') return false;
  return assetUrlType.toLowerCase() === 'external';
}

export function isDownloadType(assetUrlType) {
  if (!assetUrlType || typeof assetUrlType !== 'string') return false;
  return assetUrlType.toLowerCase() === 'download';
}

export async function tryDownloadToDevice(url) {
  if (!url) return;
  try {
    const res = await fetch(url, { mode: 'cors' });
    if (!res.ok) throw new Error('fetch failed');
    const blob = await res.blob();
    const nameFromUrl = url.split('/').pop()?.split('?')[0] || 'download';
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = nameFromUrl;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(objectUrl);
  } catch {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}

export function openExternal(url) {
  if (url) window.open(url, '_blank', 'noopener,noreferrer');
}

// the "All" tab id — kebab, consistent with the per-category slugs
export const ALL_CATEGORY_ID = 'all';

// category tabs as { id (kebab slug for the URL), label (display), value (what filterAssets matches) }
export function categoryTabs(assets) {
  const set = new Set();
  (assets || []).forEach(a => {
    (a?.categories || []).forEach(c => {
      if (c) set.add(c);
    });
  });
  const labels = [...set].sort((a, b) => a.localeCompare(b));
  return buildTabsFromLabels(labels, {
    leading: { id: ALL_CATEGORY_ID, label: 'All', value: ALL }
  });
}

export function buildCarrierList(assets) {
  const names = new Set();
  let hasNoCarrier = false;
  (assets || []).forEach(a => {
    if (a?.carrier?.name) names.add(a.carrier.name);
    else hasNoCarrier = true;
  });
  const out = [ALL, ...[...names].sort((a, b) => a.localeCompare(b))];
  if (hasNoCarrier) out.push(NO_CARRIER);
  return out;
}

export function materialTypeOptions(assets) {
  const types = new Set();
  (assets || []).forEach(a => {
    if (a?.type) types.add(a.type);
  });
  return [ALL, ...[...types].sort((a, b) => a.localeCompare(b))];
}

export function matchesCarrier(asset, selectedCarrier) {
  if (selectedCarrier === ALL) return true;
  if (selectedCarrier === NO_CARRIER) return !asset?.carrier?.name;
  return asset?.carrier?.name === selectedCarrier;
}

export function filterAssets(assets, { category, carrier, type, q }) {
  const query = (q || '').trim().toLowerCase();
  return (assets || []).filter(asset => {
    if (category && category !== ALL) {
      const cats = asset?.categories || [];
      if (!cats.includes(category)) return false;
    }
    if (!matchesCarrier(asset, carrier)) return false;
    if (type !== ALL && (asset?.type || '') !== type) return false;
    if (query) {
      const name = (asset?.name || '').toLowerCase();
      const t = (asset?.type || '').toLowerCase();
      if (!name.includes(query) && !t.includes(query)) return false;
    }
    return true;
  });
}

export function typesAvailableForCarrier(assets, selectedCarrier) {
  const s = new Set();
  (assets || []).forEach(a => {
    if (!matchesCarrier(a, selectedCarrier)) return;
    if (a?.type) s.add(a.type);
  });
  return s;
}

export function actionButtonLabel(selectedAsset) {
  if (!selectedAsset) return 'Open';
  if (isDownloadType(selectedAsset.assetUrlType)) return 'Download';
  if (isExternalType(selectedAsset.assetUrlType)) return 'Open link';
  if (selectedAsset.assetUrl) return 'Open link';
  return 'Open';
}
